import React from "react";
import { ReactSortable } from "react-sortablejs";
import { Accordion, Card, Form, Button, ButtonGroup } from "react-bootstrap";
import {
  MdAdd as AddIcon,
  MdArrowDownward as ArrowDownwardIcon,
  MdArrowUpward as ArrowUpwardIcon,
  MdDelete as DeleteIcon,
} from "react-icons/md";

const SongForm = ({ i, item, state, setState }) => {
  const handleInputChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    // const [index, name] = target.name.split("-", 2);

    setState((oldState) => {
      let items = [...oldState];
      items[i][target.name] = value;
      return items;
    });
  };

  return (
    <Form className="p-5">
      <Form.Group>
        <Form.Label>Album ID</Form.Label>
        <Form.Control
          type="text"
          name="albumId"
          value={item.albumId}
          onChange={handleInputChange}
        ></Form.Control>
      </Form.Group>
      <Form.Group>
        <Form.Label>Song</Form.Label>
        <Form.Control
          type="text"
          name="title"
          value={item.title}
          onChange={handleInputChange}
        ></Form.Control>
      </Form.Group>
      <Form.Group>
        <Form.Label>Artist</Form.Label>
        <Form.Control
          type="text"
          name="artist"
          value={item.artist}
          onChange={handleInputChange}
        ></Form.Control>
      </Form.Group>
      <Form.Group>
        <Form.Label>Album</Form.Label>
        <Form.Control
          type="text"
          name="album"
          value={item.album}
          onChange={handleInputChange}
        ></Form.Control>
      </Form.Group>
      <Form.Group>
        <Form.Label>Genre</Form.Label>
        <Form.Control
          type="text"
          name="genre"
          value={item.genre}
          onChange={handleInputChange}
        ></Form.Control>
      </Form.Group>
      <Form.Group>
        <Form.Label>Label</Form.Label>
        <Form.Control
          type="text"
          name="label"
          value={item.label}
          onChange={handleInputChange}
        ></Form.Control>
      </Form.Group>
      <Form.Check
        type="checkbox"
        label="Texas Artist"
        name="txArtist"
        checked={item.txArtist}
        onChange={handleInputChange}
      />
      {/* <Form.Group>
        <Form.Label>Song</Form.Label>
        <Form.Control
          type="text"
          name="song"
          value={item.song}
          onChange={handleInputChange}
        ></Form.Control>
      </Form.Group> */}
      <ButtonGroup>
        <Button
          disabled={i <= 0}
          onClick={() =>
            setState((state) => {
              let newState = [...state];
              [newState[i], newState[i - 1]] = [newState[i - 1], newState[i]];
              return newState;
            })
          }
        >
          <ArrowUpwardIcon />
        </Button>
        <Button
          disabled={i >= state.length - 1}
          onClick={() =>
            setState((state) => {
              let newState = [...state];
              [newState[i], newState[i + 1]] = [newState[i + 1], newState[i]];
              return newState;
            })
          }
        >
          <ArrowDownwardIcon />
        </Button>
      </ButtonGroup>
      <ButtonGroup className="float-end">
        <Button
          disabled={state.length <= 1}
          onClick={() =>
            setState((state) => {
              state = [...state];
              state[i].delete = true;
              return state;
            })
          }
        >
          <DeleteIcon />
        </Button>
        <Button
          disabled={state.length === 1000}
          onClick={() =>
            setState((state) => [
              ...state,
              {
                _id:
                  Math.max(...state.map((song) => parseInt(song._id) || 0)) + 1,
              },
            ])
          }
        >
          <AddIcon />
        </Button>
      </ButtonGroup>
    </Form>
  );
};

const SongsForm = ({ state, setState }) => {
  // Required or else the fields will get reloaded
  React.useEffect(() => {}, []);

  let songs = [];
  for (let i = 0; i < state.length; i++)
    if (!state[i].delete)
      songs.push(
        <Accordion.Item
          key={`${i}-${state[i].id || state[i]._id}`}
          className={state[i].delete ? "d-none" : null}
          eventKey={state[i].id || state[i]._id}
        >
          <Accordion.Header>
            {state[i].title && state[i].artist
              ? `${state[i].title} - ${state[i].artist}`
              : `Song #${i}`}
          </Accordion.Header>
          <Accordion.Body eventKey={state[i].id || state[i]._id}>
            <SongForm item={state[i]} i={i} state={state} setState={setState} />
          </Accordion.Body>
        </Accordion.Item>
      );

  return (
    <ReactSortable
      tag={Accordion}
      defaultActiveKey={1}
      list={state}
      setList={setState}
      // delayOnTouchStart={true}
      // delay={2}
    >
      {songs}
    </ReactSortable>
  );
};

export default SongsForm;
